//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {disabled, id, placeholder} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './IconlessSelect.css';
import Select, { components } from 'react-select';
import type {
  isClearable,
  isSearchable, isSelectMenuWide, menuPlacement, noOptionsMessage,
  onSelectChange,
  selectedOption, selectOptions
} from "../../../../services/flowTypes/componentFlowTypes";
import TextOverflowHandler from "../../Containers/TextOverflowHandler/TextOverflowHandler";

type Props = {
  id?: id,
  addClasses?: addClasses,
  isSearchable?: isSearchable,
  value: selectedOption,
  onChange: onSelectChange,
  options: selectOptions,
  placeholder?: placeholder,
  noOptionsMessage?: noOptionsMessage,
  isClearable?: isClearable,
  isDisabled?: disabled,
  inputId?: id,
  isSelectMenuWide?: isSelectMenuWide,
  maxMenuHeight?: number,
  menuPlacement?: menuPlacement,
  isSingleValueBold12Black?: boolean,
  isSingleValueMainAccentColor?: boolean
};

const IconlessSelect = (props: Props) => {
  const selectProps = {...props};
  const isSearchable = props.isSearchable ? props.isSearchable : false;
  const isClearable = props.isClearable ? props.isClearable : false;
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      cursor: 'pointer',
      backgroundColor: 'transparent',
      border: 'unset',
      minHeight: 'var(--el-height)'
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display: "none"
      // backgroundColor: 'transparent'
    }),
    menuList: (provided, state) => ({
      ...provided,
      backgroundColor: '#ffffff'
    }),
    menu: (provided, state) => ({
      ...provided,
      left: props.isSelectMenuWide ? '-50%' : '0',
      width: props.isSelectMenuWide ? '200%' : '100%',
      boxShadow: "var(--select-box-shadow)"
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: props.isSingleValueBold12Black ? 'var(--black-text-color)' :
        props.isSingleValueMainAccentColor ? 'var(--main-accent-color)' : 'var(--dark-text-color)',
      fontFamily: 'var(--main-font-family)',
      fontSize: props.isSingleValueBold12Black ? '12px' :
        props.isSingleValueMainAccentColor ? '18px' : '14px',
      fontWeight: props.isSingleValueBold12Black ? 'bold' : 'normal',
      lineHeight: '40px'
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      justifyContent: props.isSingleValueMainAccentColor ? "center" : "unset"
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: '14px'
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? 'var(--main-accent-color)' : 'var(--main-text-color)',
      backgroundColor: state.isFocused ? 'var(--item-back-color)' : '#ffffff',
      fontFamily: 'var(--main-font-family)',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '40px'
    })
  };
  const Option = (props) => {
    const label = typeof props.data.label === 'string' ?
      props.data.statusClassName ?
        <span className={props.data.statusClassName}>{props.data.label}</span> :
        <TextOverflowHandler addClasses={'TextOverflowHandler_mw-100'}>{props.data.label}</TextOverflowHandler>
      : props.data.label;
    const innerProps = {...props.innerProps, id: props.data.value,
      "data-ui-test-id": selectProps.id + "_" + props.data.value};
    const newProps = {...props, innerProps: innerProps, children: label};
    return (
      <components.Option {...newProps} />
    );
  };
  const className = props.isDisabled ? "IconlessSelect IconlessSelect_disabled" : "IconlessSelect";
  const transformedComponents = {
    DropdownIndicator: ()=> {return null;},
    Option: Option
  };
  return (
    <div id={props.id} className={baseClass(className, props.addClasses)}>
      <Select
        menuPlacement={props.menuPlacement}
        maxMenuHeight={props.maxMenuHeight}
        components={transformedComponents}
        noOptionsMessage={props.noOptionsMessage}
        placeholder={props.placeholder}
        isClearable={isClearable}
        isSearchable={isSearchable}
        value={props.value}
        onChange={props.onChange}
        options={props.options}
        styles={customSelectStyles}
        inputId={props.inputId}
        isDisabled={props.isDisabled}
        // defaultMenuIsOpen={true}
      />
    </div>
  );
};

export default IconlessSelect;